module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_feature01-a6c2be02dba85952440786ce27b87086.jpg";